import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 2.5rem;
    box-sizing: border-box;
    user-select: none;
    padding: 0.5rem 1.2rem;
    gap: 5px;
    width: 100%;
    :hover {
        background-color: ${ThemeColors.getGrayColor(0.03)};
    }
`

export const SkeletonTitle = styled.div`
    width: 200px;
    height: 20px;
`

export const SkeletonDescription = styled.div`
    width: 250px;
    height: 15px;
`
export const Title = styled.span`
    white-space: nowrap;
`

export const DescriptionBlock = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    outline: none;
    font-size: 0.8rem;
`

export const Description = styled.span`
    white-space: nowrap;
    color: ${ThemeColors.getGrayColor(0.4)};
`
